'use strict';

var $    = require('jquery');
var _    = require('underscore');
var InspectorCore = require('../core/core_inspector.js');

/**
 * Creates an inspector with value and unit
 *
 * @class
 */

class InspectorValueUnitCheck extends InspectorCore {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'value': '',
				'units': [],
				'checked': false,
                'tooltip': ''
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item editor__inspector__item--single">
				<div class="editor__inspector__item__label" title="<%- tooltip %>"><%- title %></div>
  				<input class="editor__inspector__item__textinput editor__inspector__item__textinput--align-right js-inspector__textinput__value" type="text" value="<%- value %>">
  				<select class="editor__inspector__item__select js-inspector__select">
  					<% _.each(units, function(i){ %>
  						<option><%- i %></option>
  					<% }); %>
  				</select>
				<div class="editor__inspector__item__checkbox__container">
					<input class="editor__inspector__item__checkbox js-editor__inspector__item__checkbox" type="checkbox" <% if(checked){ %><%- "checked" %><% } %>>
				</div>
			</div>
		`;

		super.render();

		/**
		* Text input
		*
		* @fires InspectorValueUnitCheck#_valuechanged
		*/

		$('.js-inspector__textinput__value', this.$el).on('input', this._valuechanged);
		$('.js-inspector__textinput__value', this.$el).on('focus', this._focus);
		$('.js-inspector__textinput__value', this.$el).on('blur', this._blur);

         var self = this;
         $('.js-inspector__textinput__value', this.$el).keypress(function(e) {
            if (e.which == 13) {
                self._enter(e);
            }
        });

		$('.js-inspector__select', this.$el).show();
		/**
		* Selectbox
		*
		* @fires InspectorValueUnitCheck#_unitchanged
		*/
		$('.js-inspector__select', this.$el).on('change', this._unitchanged);

		/**
		* Checkbox
		*
		* @fires InspectorValueUnitCheck#_checkboxchanged
		*/

		$('.js-editor__inspector__item__checkbox', this.$el).on('change', this._checkboxchanged);
	}

	/**
     * @event InspectorValueUnitCheck#Cioui:Inspector:value
     * @property {String}Cioui:Inspector:value
     * @returns {String} value - the new text input obj
     */

	_valuechanged(e){
		$(e.currentTarget).trigger('Cioui:Inspector:value', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:focus
     * @property {String}Cioui:Inspector:focus
     * @returns {String} value - the new text input obj
     */
	_focus(e){
		$(e.currentTarget).trigger('Cioui:Inspector:focus', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnit#Cioui:Inspector:blur
     * @property {String}Cioui:Inspector:blur
     * @returns {String} value - the new text input obj
     */
	_blur(e){
		$(e.currentTarget).trigger('Cioui:Inspector:blur', $(e.currentTarget).val());
	}

    /**
     * @event InspectorValueUnit#Cioui:Inspector:enter
     * @property {String}Cioui:Inspector:enter
     * @returns {String} value - the new text input obj
     */
    _enter(e){
        $(e.currentTarget).trigger('Cioui:Inspector:enter', $(e.currentTarget).val());
    }

	/**
     * @event InspectorValueUnitCheck#Cioui:Inspector:unit
     * @property {String}Cioui:Inspector:unit
     * @returns {String} value - unit value
     */

	_unitchanged(e){
		$(e.currentTarget).trigger('Cioui:Inspector:unit', $(e.currentTarget).val());
	}

	/**
     * @event InspectorValueUnitCheck#Cioui:Inspector:boolean
     * @property {String}Cioui:Inspector:boolean
     * @returns {Boolean} value - true if checkbox is checked, false if not
     */

	_checkboxchanged(e){
		$(e.currentTarget).trigger('Cioui:Inspector:boolean', ($(e.currentTarget).is(':checked') ? true : false));
	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setValue(value){
		$('.js-inspector__textinput__value', this.$el).val(value);
	}

	/**
	* setUnit
	*
	* @param {string} unit - the unit that you want to set
	*/

	setUnit(unit){
		$('.js-inspector__select', this.$el).val(unit);
	}

	/**
	* setBoolean
	*
	* @param {Boolean} checked - set a boolean that checks the checkbox
	*/

	setBoolean(checked){
		$('.js-editor__inspector__item__checkbox', this.$el).prop('checked', checked);
	}

}
module.exports = InspectorValueUnitCheck;
